// OptionsDialog.js
import { useState, useEffect } from "react"
import { Typography, Button } from '@mui/material'
import OptionsGeneralForm from './OptionsGeneralForm'
import OptionsDatesForm from './OptionsDatesForm'
import OptionsTimeStepsForm from './OptionsTimeStepsForm'
import OptionsDynamicWaveForm from "./OptionsDynamicWaveForm"
import "../../css/DemoCode.css"



/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @returns UI for interactive swmm modeling.
 */
export default function OptionsDialog({model, setModel}) {
  const [submodel, setSubmodel] = useState({})

  useEffect(()=>{
    let OPTIONS = {}

    if(model.OPTIONS){
      OPTIONS = model.OPTIONS
    } else {
      OPTIONS = {
        "FLOW_UNITS": "CFS",
        "INFILTRATION": "HORTON",
        "FLOW_ROUTING": "DYNWAVE",
        "LINK_OFFSETS": "DEPTH",
        "MIN_SLOPE": "0",
        "ALLOW_PONDING": "YES",
        "SKIP_STEADY_STATE": "NO",
        "START_DATE": "01/01/2002",
        "START_TIME": "00:00:00",
        "REPORT_START_DATE": "01/01/2002",
        "REPORT_START_TIME": "00:00:00",
        "END_DATE": "01/01/2002",
        "END_TIME": "06:00:00",
        "SWEEP_START": "01/01",
        "SWEEP_END": "12/31",
        "DRY_DAYS": "0",
        "REPORT_STEP": "00:01:00",
        "WET_STEP": "00:15:00",
        "DRY_STEP": "01:00:00",
        "ROUTING_STEP": "0:00:05",
        "RULE_STEP": "00:00:00",
        "INERTIAL_DAMPING": "NONE",
        "NORMAL_FLOW_LIMITED": "BOTH",
        "FORCE_MAIN_EQUATION": "D-W",
        "VARIABLE_STEP": "0.00",
        "LENGTHENING_STEP": "0",
        "MIN_SURFAREA": "12.557",
        "MAX_TRIALS": "8",
        "HEAD_TOLERANCE": "0.005",
        "SYS_FLOW_TOL": "5",
        "LAT_FLOW_TOL": "5",
        "MINIMUM_STEP": "0.5",
        "THREADS": "1"
      }
    }

    setSubmodel({
      OPTIONS: OPTIONS
    })
  },[])

  const saveEdits = () => {
    let cleanSub = JSON.parse(JSON.stringify(submodel))
    
    setModel(prev => ({
      ...prev,
      OPTIONS:{
        ...cleanSub.OPTIONS
      }
    }))
  }

  function openTab(evt, tabName) {
    var i, tabcontent, tablinks
  
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent")
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none"
    }
  
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks")
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "")
    }
  
    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(tabName).style.display = "block"
    evt.currentTarget.className += " active"
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  return(
    <>
    {
      <>
        <Typography id="modal-modal-title" variant="p4" >
          <div style={{display:"flex", flexDirection: "column"}}>
            <label>Options</label>
          </div>
        </Typography>
        <div>
          <Button fullWidth onClick={saveEdits} >Save Edits</Button>
        </div>
        <div style={{background:'black', overflowY: 'hidden'}}>
          {
            <>
            <div className="tab">
              <Button className="tablinks" onClick={(e)=>openTab(e, 'General')}>General</Button>
              <Button className="tablinks" onClick={(e)=>openTab(e, 'Dates')}>Dates</Button>
              <Button className="tablinks" onClick={(e)=>openTab(e, 'Time Steps')}>Time Steps</Button>
              <Button className="tablinks" onClick={(e)=>openTab(e, 'Dynamic Wave')}>Dynamic Wave</Button>
              <Button className="tablinks" onClick={(e)=>openTab(e, 'Files')}>Files</Button>
            </div>
            
            <div id="General" style={{display: 'block'}} className="tabcontent active">
              {<OptionsGeneralForm model={submodel} setModel={setSubmodel} fullModel={model} />}
            </div>

            <div id="Dates" className="tabcontent">
              {<OptionsDatesForm model={submodel} setModel={setSubmodel} fullModel={model} />}
            </div>

            <div id="Time Steps" className="tabcontent">
              {<OptionsTimeStepsForm model={submodel} setModel={setSubmodel} fullModel={model} />}
            </div>

            <div id="Dynamic Wave" className="tabcontent">
              {<OptionsDynamicWaveForm model={submodel} setModel={setSubmodel} fullModel={model} />}
            </div>
            
            <div id="Files" className="tabcontent">
              
            </div>
            <div className="infocol">
            </div>
            </>
          }
        </div>
        </>
      }
    </>
  )
} 